import * as React from "react";
import { Component } from "react";
import { connect } from "react-redux";

import CreditNotes from "../../screens/CreditNotes";

import { fetchCreditNotes, pageSelected } from "./action";

class CreditNotesContainer extends Component {
  render() {
    return (
      <CreditNotes
        fetchCreditNotes={this.props.fetchCreditNotes}
        CreditNotesDetails={this.props.CreditNotesDetails}
        CreditNotesCount={this.props.CreditNotesCount}
        pageSelected={this.props.pageSelected}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchCreditNotes: value => {
      dispatch(fetchCreditNotes(value));
    },
    pageSelected: value => {
      dispatch(pageSelected(value));
    }
  };
}

const mapStateToProps = state => {
  return {
    CreditNotesDetails: state.CreditNotesReducer.CreditNotesDetails,
    CreditNotesCount: state.CreditNotesReducer.CreditNotesCount
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(CreditNotesContainer);
